import { render, staticRenderFns } from "./BrowseListCard.vue?vue&type=template&id=4ca9cd46&scoped=true"
import script from "./BrowseListCard.vue?vue&type=script&lang=ts"
export * from "./BrowseListCard.vue?vue&type=script&lang=ts"
import style0 from "./BrowseListCard.vue?vue&type=style&index=0&id=4ca9cd46&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca9cd46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ca9cd46')) {
      api.createRecord('4ca9cd46', component.options)
    } else {
      api.reload('4ca9cd46', component.options)
    }
    module.hot.accept("./BrowseListCard.vue?vue&type=template&id=4ca9cd46&scoped=true", function () {
      api.rerender('4ca9cd46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/BrowseListCard.vue"
export default component.exports